import {Register} from "../../genes/Register"

export const ChunkBase = Register.global("$hxClasses")["tink.chunk.ChunkBase"] = 
class ChunkBase {
	flatten(into) {
	}
	static get __name__() {
		return "tink.chunk.ChunkBase"
	}
	get __class__() {
		return ChunkBase
	}
}

